export default __webpack_public_path__ + "static/media/promo_03.caca04f4.jpg";